module.exports = __webpack_public_path__ + "static/media/landingpage.782075f7.jpg";